import { useQuery } from '@tanstack/react-query';

import { getRoadmap } from '../queries/getRoadmap.ts';

export const useRoadmap = (
  territorySlug: string,
  vehicleId: number | undefined,
  vehicleProviderId: string | undefined,
) => {
  return useQuery({
    queryKey: ['roadmap', territorySlug, vehicleProviderId],
    queryFn: ({ signal }) => getRoadmap(territorySlug, vehicleId, signal),
    enabled: !!vehicleProviderId,
    throwOnError: true,
  });
};
